import React, { Component } from 'react';
import { Typography, Grid, List, ListItem, ListItemSecondaryAction, ListItemText, ListItemAvatar, IconButton, Card, Box, Table, TableBody, TableRow, TableCell, TextField } from '@material-ui/core';
import InputText from '../../../commonModules/interface/form-input-inline';
import PopUp from '../../../commonModules/interface/PopUp';
import Currency from '../../../commonModules/Currency';
import { CloseRounded, SearchRounded } from '@material-ui/icons';
import { isEmpty, size } from 'lodash';
import { Alert } from '@material-ui/lab';
import IncomeDetails from './IncomeDetails';
import LinkIncome from './LinkIncome';
import { matched, remaining, isPartiallyMatched, amountError } from '../../../../../../jsx/utils/paymentIncomeLinks';


class LinkPaymentPopUp extends Component {
    state = {
    }

    render() {
        const { PAYMENTS, checkedPayments, handleChange, incomeID, getIncomeInfo, handleSubmitLink, totalPay, handleClose, linkAmounts, handleChangeAmount, amountsError} = this.props;
        return (
            <LinkIncome
                title="Pointer les paiements "
                handleChange={handleChange}
                incomeID={incomeID}
                getIncomeInfo={getIncomeInfo}
                handleSubmitLink={handleSubmitLink}
                totalPay={totalPay}
                amountsError={amountsError}
                handleClose={handleClose}
            >
                {(checkedPayments && Array.isArray(checkedPayments) ? checkedPayments : []).map( (payID, index) => {
                    const payment = PAYMENTS[payID]
                    // Montant à pointer sur cette recette : par défaut le reste, borné par lui.
                    const max = remaining(payment)
                    const value = linkAmounts && linkAmounts[payID] !== undefined ? linkAmounts[payID] : max
                    const error = amountError(value, max)
                    return (
                        <ListItem key={payID} divider>
                            <ListItemAvatar onClick={() => this.props.rmPayment(payID)} style={{ cursor: "pointer"}}>
                                <CloseRounded color="error" />
                            </ListItemAvatar>
                            <ListItemText
                                primary={payment.userName}
                                secondary={
                                    <React.Fragment>
                                        <span style={{ display: "block" }}>{new Date(payment.timePayment).toLocaleString('fr-FR')}</span>
                                        <span style={{ display: "block" }}>Paiement : <Currency value={payment.money} /></span>
                                        {isPartiallyMatched(payment) &&
                                            <span style={{ display: "block" }}>Déjà pointé : <Currency value={matched(payment)} /></span>
                                        }
                                    </React.Fragment>
                                }
                            />
                            <Box pl={1} style={{ width: 170, flexShrink: 0 }}>
                                <TextField
                                    label="Montant à pointer"
                                    type="number"
                                    size="small"
                                    variant="outlined"
                                    color="secondary"
                                    value={value}
                                    onChange={(e) => handleChangeAmount && handleChangeAmount(payID, e.target.value)}
                                    onWheel={(e) => e.target.blur()}
                                    inputProps={{ min: 0, max, step: "any" }}
                                    error={!!error}
                                    helperText={error || `Reste : ${max}`}
                                />
                            </Box>
                        </ListItem>
                    )
                })}
            </LinkIncome>
        );
    }
}

export default LinkPaymentPopUp;
